exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".terms_container {\n  margin: 2rem 0rem 0rem;\n}\n@media only screen and (max-width: 35.938rem) {\n  .terms_container {\n    text-align: center;\n  }\n}\n.terms_container a {\n  color: #F9602C;\n  text-decoration: underline;\n}\n", ""]);

